"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ComponentWrapper = _interopRequireDefault(require("../../ComponentWrapper"));

var _Layout = require("../../Layout");

var _Banner = _interopRequireDefault(require("../../Banner"));

var _Hero = require("../Hero.style");

var HeroArticle = function HeroArticle(_ref) {
  var banner = _ref.banner,
      hero = _ref.hero,
      title = _ref.title,
      wrapperProps = _ref.wrapperProps;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: hero.articleColumnWidth
  }, /*#__PURE__*/_react.default.createElement(_Hero.HeroHeadline, {
    size: hero.articleTitleSize,
    my: "xxxlarge",
    variant: "article"
  }, title)), /*#__PURE__*/_react.default.createElement(_Hero.MediaWrapper, Object.assign({
    variant: "article"
  }, wrapperProps), /*#__PURE__*/_react.default.createElement(_Hero.Overlay, null, banner && /*#__PURE__*/_react.default.createElement(_Hero.HeroBanner, null, /*#__PURE__*/_react.default.createElement(_Banner.default, Object.assign({}, banner, {
    textColor: hero.bannerTextColor
  }))), /*#__PURE__*/_react.default.createElement(_Layout.Container, null))));
};

HeroArticle.propTypes = {
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({
      src: _propTypes.default.string,
      fluid: _propTypes.default.shape({}),
      fixed: _propTypes.default.shape({})
    }),
    label: _propTypes.default.string
  }),
  hero: _propTypes.default.shape({
    articleColumnWidth: _propTypes.default.arrayOf(_propTypes.default.number),
    bannerTextColor: _propTypes.default.string,
    articleTitleSize: _propTypes.default.string
  }),
  title: _propTypes.default.string,
  wrapperProps: _propTypes.default.shape({})
};
HeroArticle.defaultProps = {
  banner: null,
  hero: null,
  title: null,
  wrapperProps: null
};
var _default = HeroArticle;
exports.default = _default;